import { createFileRoute } from '@tanstack/react-router';
import { AboutPage } from '@/components/marketing/pages/AboutPage';

export const Route = createFileRoute('/_marketing/about')({
  component: AboutPage,
});
